export const carSelector = {
	init: function(container) {
		this.allSelectInputs = [].slice.call(container.querySelectorAll('select'));
		this.resultsContainer = container.querySelector('.results-table__wrapper');
		this.resultsPlaceholder = container.querySelector('.results-table__placeholder');
		this.loader = container.querySelector('.car-selector-form__loader-wrapper');
		this.inputToDataInsert;
		this.baseUrl = '/json/';
		this.queryUrl = '';
		this.requestUrl = '';
		this.assignListeners();
	},

	assignListeners: function() {
		window.addEventListener('load', _=> {
			this.inputToDataInsert = this.allSelectInputs[0];
			this.sendRequest(this.baseUrl + 'getmakes');
		});
		
		this.allSelectInputs.forEach(el=> {
			el.addEventListener('change', (e)=> {
				const queryType = e.currentTarget.dataset.query,
					  selectType = e.currentTarget.dataset.type;			
				this.inputToDataInsert = e.currentTarget.nextElementSibling;
				
				this.createUrl(selectType, queryType, e.currentTarget);
				this.sendRequest(this.requestUrl);
			});
		});
	},

	createUrl: function(selectType, queryType, selectedEl) {
		const value = selectedEl.value;
		if (this.queryUrl.indexOf(selectType) >= 0) {
			
			this.filterSelectedInput(selectedEl);
			const queryIndex = this.queryUrl.indexOf(selectType),
				  newStr = this.queryUrl.replace(this.queryUrl.slice(queryIndex, this.queryUrl.length), '');			
			this.queryUrl = newStr;
		}
		this.queryUrl += selectType + '=' + encodeURIComponent(value) + '&';		
		this.requestUrl = this.baseUrl + queryType + '?' + this.queryUrl;
	},

	filterSelectedInput: function(selectedEl) {
		const index = this.allSelectInputs.indexOf(selectedEl);
		const newArr = this.allSelectInputs.slice(index + 1);
		this.resultsContainer.innerHTML = '';
		this.resultsPlaceholder.classList.remove('hidden');
		newArr.forEach(select=> {
			select.disabled = true;
			const optionsToClear = select.querySelectorAll('option:not([disabled])'),
				  firstOption = select.querySelector('option');
			[].slice.call(optionsToClear).forEach(option=> {
				select.removeChild(option);
				firstOption.selected = 'selected'
			});
		});
	},

	selectEnable: function(select) {
		select.disabled = false;
	},

	sendRequest: function(query) {
		this.loader.style.display = 'flex';
		const requestLink = query,
				httpRequest = new XMLHttpRequest();
		httpRequest.onload = _=> {
			this.handleResults(httpRequest);
		};
		httpRequest.open('GET', requestLink);
		httpRequest.send();
	},

	handleResults: function(httpRequest) {
		if (httpRequest.readyState === 4 && httpRequest.status === 200) {
			const parsedData = JSON.parse(httpRequest.responseText);
			if (!this.inputToDataInsert) {
				this.insertSearchResult(parsedData);
				return;
			} 
			this.selectEnable(this.inputToDataInsert);
			this.dropdownDataInsert(parsedData);
		}
	},

	dropdownDataInsert: function(parsedData) {
		const queryProperty = this.inputToDataInsert.dataset.type;
		let data = {},
			arr = [];
		
		for (const key in parsedData[queryProperty]) {
			if (parsedData[queryProperty][key].hasOwnProperty('name')) {
				data.data = parsedData[queryProperty];
				break;
			} else {
				arr.push({name: parsedData[queryProperty][key]})
				data.data = arr;
			}	
		}
		
		const template = document.querySelector('#car-selector-option').innerHTML;
		Mustache.parse(template);
		const rendered = Mustache.render(template, data);
		this.inputToDataInsert.innerHTML += rendered;
		this.loader.style.display = 'none';

		if (data.data.length === 1) this.selectOnlyResult();
	},

	selectOnlyResult: function() {
		const onlyOption = this.inputToDataInsert.querySelector('option:not([disabled])');
		onlyOption.selected = 'selected';
		const selectedType = this.inputToDataInsert.dataset.type,
			  queryType = this.inputToDataInsert.dataset.query;
		this.createUrl(selectedType, queryType, this.inputToDataInsert);
		this.inputToDataInsert = this.inputToDataInsert.nextElementSibling;		
		this.sendRequest(this.requestUrl);
	},

	insertSearchResult: function(resultsData) {
		this.resultsPlaceholder.classList.add('hidden');
		const resultTableTemplate = document.querySelector('#results-table').innerHTML;
		Mustache.parse(resultTableTemplate);
		const rendered = Mustache.render(resultTableTemplate, resultsData);
		this.resultsContainer.innerHTML = rendered;
		this.loader.style.display = 'none';
	}
}
